import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, OnInit } from '@angular/core';

import { DataCyDirective } from '@base/common/directives/data-cy.directive';
import { PriceComponent } from '@base/trilogy/price/price.component';

import { ProductLine, SubtitleType } from '@interfaces/checkout.interface';

import { TicketTooltipComponent } from '../ticket-tooltip/ticket-tooltip.component';

@Component({
    selector: 'checkout-ticketline',
    standalone: true,
    imports: [CommonModule, PriceComponent, TicketTooltipComponent, DataCyDirective],
    templateUrl: './ticketline.component.html',
    styleUrl: 'ticketline.component.scss',
})
export class TicketlineComponent implements OnInit, OnChanges {
    @Input() public ticketLine: ProductLine;
    @Input() public showPrice: boolean;
    @Input() public isReprise: boolean = false;
    @Input() public label: string;
    @Input() public subtitles: SubtitleType[];
    @Input() public dataTcCategory: string;
    @Input() public priceCheckoutCy: string;
    @Input() public labelCheckoutCy: string;
    @Input() public totalPrice: number;
    @Input() public isTitle: boolean;
    @Input() public hasPeriod: boolean = false;

    public price: number;
    public allSubTitles: SubtitleType[];
    public subTitlesWithPrice: SubtitleType[];
    public subTitlesLabelOnly: SubtitleType[];

    ngOnInit(): void {
        this.refresh();
    }

    ngOnChanges(): void {
        this.refresh();
    }

    private refresh(): void {
        this.price = this.totalPrice || this.ticketLine?.price;
        this.allSubTitles = this.subtitles || this.ticketLine?.subtitles || [];

        const subTitlesWithPrice = this.allSubTitles.filter((subtitle) => subtitle.price);
        const subTitlesLabelOnly = this.allSubTitles.filter((subtitle) => !subtitle.price);

        this.subTitlesWithPrice = subTitlesWithPrice;
        this.subTitlesLabelOnly = subTitlesLabelOnly;
    }
}
